enum ApprovalResultModeEnum {
    REJECTED = "REJECTED",
    ACCEPTED = "ACCEPTED"
}

export default ApprovalResultModeEnum;
